import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates.ts";
import { invalidateAllReturnWorkflowsKey } from "./use-get-all-return-workflows.ts";
import { useApiMutation } from "./use-api-mutation";

export default function useDeleteReturnWorkflow(shopId: string) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/return-workflows/{workflowId}",
		{
			notify: false,
			meta: {
				success: {
					title: "workflows.editor.delete.success.title",
					message: "workflows.editor.delete.success.message",
				},
				error: {
					title: "workflows.editor.delete.error.title",
					message: "workflows.editor.delete.error.message",
				},
				invalidatesQuery: [
					invalidateAllReturnWorkflowsKey(shopId),
					invalidateAllShopEmailTemplatesKey(shopId),
				],
			},
			mapVariables: (id: string) => ({
				params: { path: { shopId, workflowId: id } },
			}),
		},
	);
}
